import { render, staticRenderFns } from "./PermissionsCardPage.vue?vue&type=template&id=2ab7c970"
import script from "./PermissionsCardPage.vue?vue&type=script&lang=js"
export * from "./PermissionsCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports